
class customTabs extends HTMLElement {
    constructor() {
        super();


        const tabs = this.querySelectorAll('li');
        const tabContents = this.querySelectorAll('.tab_content')

        for (const tab of tabs) {
            tab.addEventListener('click', () => {

                tabs.forEach(
                    tab => tab.classList.remove('selected_tab')
                );

                tab.classList.add('selected_tab');

                tabContents.forEach(
                    tabContent => tabContent.classList.remove('active_tab')
                );

                const tabContent = this.querySelector(`.tab_content[data_tab_id="${tab.id}"]`);

                if (tabContent) {
                    tabContent.classList.add('active_tab');
                }
            });
        }

    }
}
customElements.define('custom-tabs', customTabs);

